import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cro',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './cro.html',
  styleUrl: './cro.css'
})
export class CroComponent {
  features = [
    {
      title: 'A/B Testing',
      description: 'Run systematic experiments to compare different versions of your pages and identify what drives conversions.',
      icon: 'psychology'
    },
    {
      title: 'Landing Page Optimization',
      description: 'Optimize every element of your landing pages to maximize conversion rates and reduce bounce rates.',
      icon: 'web'
    },
    {
      title: 'UX Analysis',
      description: 'Analyze user experience to identify friction points and opportunities for improving conversion flows.',
      icon: 'insights'
    },
    {
      title: 'Heatmaps & Session Recording',
      description: 'Understand user behavior with visual heatmaps and session recordings to see how visitors interact with your site.',
      icon: 'visibility'
    },
    {
      title: 'User Research',
      description: 'Conduct surveys, interviews, and usability tests to understand your audience and their motivations.',
      icon: 'groups'
    },
    {
      title: 'Multivariate Testing',
      description: 'Test multiple variables simultaneously to find the optimal combination of elements for maximum conversions.',
      icon: 'tune'
    }
  ];

  process = [
    {
      step: '01',
      title: 'Audit & Analysis',
      description: 'We analyze your current conversion funnel, identify bottlenecks, and prioritize optimization opportunities based on data and user behavior patterns.'
    },
    {
      step: '02',
      title: 'Hypothesis Development',
      description: 'Based on research and analytics, we develop testable hypotheses about what changes will improve conversion rates and create a testing roadmap.'
    },
    {
      step: '03',
      title: 'Testing & Experimentation',
      description: 'We design and run A/B and multivariate tests, monitor results in real-time, and ensure statistical significance before making decisions.'
    },
    {
      step: '04',
      title: 'Implementation & Iteration',
      description: 'Winning variations are implemented, and we continuously iterate with new tests to drive ongoing improvement in conversion rates.'
    }
  ];

  caseStudy = {
    client: 'TechFlow SaaS',
    industry: 'B2B Software',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=800&fit=crop',
    challenge: 'TechFlow had a high-traffic website but struggled with low trial sign-up conversion rates. Their landing pages were getting thousands of visitors, but only 1.2% were converting to trial users.',
    solution: 'We implemented a comprehensive CRO program including landing page redesign, A/B testing of CTAs, form optimization, and social proof elements. We used heatmaps to identify user behavior patterns and session recordings to understand drop-off points.',
    results: [
      { metric: 'Conversion Rate Increase', value: '285%' },
      { metric: 'Trial Sign-ups', value: '+420/month' },
      { metric: 'Cost Per Acquisition', value: '-62%' },
      { metric: 'Revenue Impact', value: '+$180K/year' }
    ]
  };

  testimonial = {
    quote: 'HoneyKode\'s CRO expertise transformed our business. They didn\'t just improve our conversion rates - they helped us understand our customers better. The systematic testing approach and data-driven insights have created a culture of optimization within our team.',
    author: 'Michael Chen',
    role: 'VP of Growth',
    company: 'TechFlow SaaS',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop'
  };
}
